import { Component, OnInit, Input } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { Poll } from '../../models/poll';
import { PollService } from '../../services/poll.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import { MessageBoxCheckDialog } from '../message-box-check/message-box-check.component';
import { Constants } from '../constants';

@Component({
  selector: 'app-poll',
  templateUrl: './poll.component.html',
  styleUrls: ['./poll.component.css']
})
export class PollComponent implements OnInit {
  publicating = false;
  @Input() PollID;
  @Input() nameComponent;
  @Input() Polls;
  createPoll = true;
  poll: Poll;
  polls: any;
  errorMessage: string;
  listQuestions = [];
  textQuestion = '';
  nameLink = '';
  urlLink = '';
  typeQuestion: number;
  descriptionQuestion: string;
  name_poll: string;

  constructor(public dialogRef: MdDialogRef<PollComponent>, private dialog: MdDialog, private pollService: PollService) { }

  ngOnInit() {
    if (this.nameComponent === 'Crear') {
      this.createPoll = true;
    } else {
      this.createPoll = false;
    }

    this.poll = new Poll();
    if (this.PollID !== '') {
      this.polls = this.Polls;
      if (this.polls.length > 0) {
        this.polls = this.Polls;
        this.getPoll(this.PollID);
      } else {
        this.polls = [new Poll()];
      }
    }
    this.typeQuestion = 1;
  }

  getPoll(id){
    for(let i = 0; i < this.polls.length; i++) {
      if(id === this.polls[i].id) {
        this.poll = this.polls[i];
        this.name_poll = this.poll.name;
        this.poll.items.forEach(element => {
            this.listQuestions.push(element);
        });
      }
    }
  }

  onPollCheck(){
    if (this.createPoll) {
      this.onPostPoll();
    } else {
      this.onPutPoll();
    }
  }

  onPoll() {
    const dialogRef = this.dialog.open(MessageBoxCheckDialog);
    dialogRef.componentInstance.checkingData = true;
    dialogRef.componentInstance.message = 'Las encuestas no se pueden editar, revise antes de continuar.';
    dialogRef.afterClosed().subscribe(result => {
      if (result === true) {
        this.onPollCheck();
      }
    });
  }

  onPutPoll() {
    this.publicating = true;
    const id = this.poll.id;
    this.poll = new Poll();
    this.poll.id = id;
    this.poll.name = this.name_poll;

    this.pollService.putPoll(this.poll)
      .subscribe(
        data => {
          this.polls = data;
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.json().name, alert: true, showIcon: true}});
        }
      );
  }

  onPostPoll() {
    this.addQuestion();
    this.addLink();

    this.poll.name = this.name_poll;
    this.poll.status = 1;
    this.poll.items = this.listQuestions;
    this.publicating = true;
    this.pollService.postPoll(this.poll)
      .subscribe(
        data => {
          this.polls = data;
          this.publicating = false;
          this.dialogRef.close(data);
        },
        error => {
          console.log(error);
          this.errorMessage = <any>error;
          this.publicating = false;
          this.dialog.open(MessageBoxDialog, {data: {message: error.message, alert: true, showIcon: true}});
        }
      );
  }

  getTypeName(id) {
    if (id == '1') {
      return 'Selección Simple (S/N)';
    } else if (id == '2') {
      return 'Texto (Máx 140 caractéres)';
    } else if (id == '3') {
      return 'Selección Simple (A,B,C,D)';
    } else if (id == '4') {
      return 'Selección Multiple (A,B,C,D)';
    } else {
      return 'Desconocido';
    }
  }

  addQuestion() {
    if (!this.textQuestion || !this.typeQuestion) {
      return;
    }

    if (!this.descriptionQuestion) {
      this.descriptionQuestion = '';
    }

    this.listQuestions.push({
      name: this.textQuestion,
      type: this.typeQuestion,
      description: this.descriptionQuestion,
    });

    this.textQuestion = '';
    this.typeQuestion = 1;
    this.descriptionQuestion = '';
  }

  addLink() {
    if (!this.nameLink || !this.urlLink) {
      return;
    }

    this.listQuestions.push({
      name: this.nameLink,
      // type: 3,
      // url: this.urlLink,
      description: '',
    });
  }

  removeQuestion(elm) {
    let index = -1;

    for (let _i = 0; _i < this.listQuestions.length; _i++) {
      if (this.listQuestions[_i].name === elm) {
        index = _i;
        break;
      }
    }

    if (index > -1) {
      this.listQuestions.splice(index, 1);
    }
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/poll/poll.component.ts